<template>
    <div class="main">
        <div class="title">友情链接</div>
        <div class="imgList">
            <a v-for="(item,index) in footerLeft" :key="index" :href="item.url" target="_blank">
                <img :src="item.image" alt="">
            </a>
        </div>
        <div class="footer-bottom">
            <span class="footer-number">
                <a href="http://www.beian.miit.gov.cn" target="_blank">中国移动通信联合会 China Mobile Communication Association<br>© CopyRight 2014 京ICP备08105208号</a>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            footerLeft: []
        }
    },
    mounted() {
        this.getFooterConnection()
    },
    methods: {
        getFooterConnection() {
            this.$api.get('webInfo/friendlyLink').then(res => {
                this.footerLeft = res.data.list
            })
        }
    }
}
</script>

<style lang="scss" scoped>
//scss
.main {
    padding: 26px 15.6px 11px;
    .title {
        height: 23.4px;
        font-size: 16.64px;
        font-weight: 400;
        text-align: left;
        color: #1a1b1f;
    }
    .imgList {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 18.72px;
        padding-bottom: 9px;
        border-bottom: 1px solid rgba(12, 25, 41, 0.08);
        img {
            width: 80.28px;
            height: 35.88px;
            margin: 0 5.72px 11.44px 0;
        }
    }
    .footer-bottom {
        width: 100%;
        .footer-number {
            a {
                // width: 400.72px;
                display: block;
                text-align: center;
                font-size: 10px;
                font-weight: 400;
                color: rgba(153, 153, 153, 0.6);
                line-height: 17px;
                margin: 0 auto;
            }
        }
    }
}
</style>
